import axios from "axios";
export default axios.create({
  //baseURL: "https://localhost:7295/api/applicantapi/",
  //baseURL: "https://applicantportal-test.mcl.edu.ph/api/applicantapi/",
  baseURL: "https://admissionsportal.mcl.edu.ph/api/applicantapi/",
});
